module.exports = "/_next/static/resources/photo-1-8087586edc6e38cb7bac0ca1064c2448.jpg";